import { useInView } from "react-intersection-observer"
import * as styles from "./styles.module.scss"
import Button from "../../Button"
import cx from "classnames"
import Link from "gatsby-link"
import * as React from "react"

export interface PeriodProps {
  children: string | React.ReactNode
  hasButton?: boolean
  position: "left" | "right"
}

const Period: React.FC<PeriodProps> = ({
  children,
  hasButton,
  position = "left",
}) => {
  const [ref, inView, entry] = useInView({ threshold: 1 })

  return (
    <div ref={ref}>
      <div
        className={cx({
          [styles.tile]: true,
          [styles[position]]: position,
          [styles.inView]: inView && entry && entry.intersectionRect.top > 0,
        })}
      >
        <p className={styles.paragraph}>{children}</p>
        {hasButton && (
          <Link to="/start">
            <Button type="primary" size="md" halo={true}>
              Get Started
            </Button>
          </Link>
        )}
      </div>
    </div>
  )
}

export default Period
